<script setup>
import { __, requestShipmentChange } from '@/utils';
import Invoices from '@components/invoices/invoices.vue';
import {
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
} from '@headlessui/vue';
import { computed, inject, ref } from 'vue';

const dropdownOptions = [
    {
        label: __('email'),
        value: 'email',
    },
    {
        label: __('mail'),
        value: 'mail',
    },
    {
        label: __('website'),
        value: 'website',
    },
];

const { details } = inject('account');
const currentShioppingMethod = ref(details.value?.invoice_shipping_method);
const selectedShippingMethod = computed(() => {
    const selected = dropdownOptions.find((item) => item.value === currentShioppingMethod.value);
    if(!selected) return currentShioppingMethod.value;
    else return selected.label;
});

const options = computed(() => dropdownOptions.filter((item) => item.value !== currentShioppingMethod.value && item.label !== currentShioppingMethod.value));

const handleChangeShippingMethod = async () => {
    const [response] = await requestShipmentChange(currentShioppingMethod.value);
    const data = JSON.parse(response.data);
    details.value = data;
}
</script>

<template>
    <div class="account-main">
        <div class="invoice-header">
            <h4>{{ __('My invoices') }}</h4>
            <div class="invoice-header__content">
                <strong>{{ __('How to receive the invoice') }}</strong>
                <div class="custom-dropdown">
                    <Listbox v-model="currentShioppingMethod" @update:modelValue="handleChangeShippingMethod">
                        <ListboxButton class="custom-dropdown-button">{{ selectedShippingMethod }}</ListboxButton>
                        <ListboxOptions class="custom-dropdown-options">
                            <ListboxOption v-for="(item) in options" :key="item.value" :value="item.value">
                                {{ item.label }}
                            </ListboxOption>
                        </ListboxOptions>
                    </Listbox>
                </div>
            </div>
        </div>
        <Invoices />
    </div>
</template>